module.exports = __webpack_public_path__ + "img/meunDetail12.c2843af5.png";